module.exports = __webpack_public_path__ + "static/media/bills-email.8d10f74a.svg";